function DashboardActiveMainGapAnalysis({value}) {
    return (
        <div className="rounded-lg bg-[#233648]/30 p-3 border border-[#324d67]/50">
            <span className="text-[10px] uppercase font-bold text-[#92adc9]">Gap Analysis</span>
            <div className="mt-2 space-y-2">
                <div className="flex justify-between text-sm">
                    <span className="text-[#92adc9]">Ahead ({value.position == 1 || value.position == 0 ? "--" : "P" + value.position - 1})</span>
                    <span className="font-bold text-acc-red">{(Math.floor(value["gap-ahead"]/1000 * 100) / 100).toFixed(2)}s</span>
                </div>
                <div className="w-full bg-[#111a22] h-1 rounded-full overflow-hidden">
                    <div className="bg-acc-red h-full" style={{"width": ((Math.floor(Math.abs(value["gap-ahead"])/1000 * 100) / 100)/30)*100 + "%"}}></div>
                </div>
                <div className="flex justify-between text-sm pt-1">
                    <span className="text-[#92adc9]">Behind ({value.position == value["active-cars"] ? "--" : "P" + (parseInt(value.position) + 1)})</span>
                    <span className="font-bold text-acc-green">{(Math.floor(value["gap-behind"]/1000 * 100) / 100).toFixed(2)}s</span>
                </div>
                <div className="w-full bg-[#111a22] h-1 rounded-full overflow-hidden">
                    <div className="bg-acc-green h-full" style={{"width": ((Math.floor(Math.abs(value["gap-behind"])/1000 * 100) / 100)/30)*100 + "%"}}></div>
                </div>
            </div>
        </div>
    );
}

export default DashboardActiveMainGapAnalysis;